module.exports = __webpack_public_path__ + "static/media/seo-min.4cda7221.png";